import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37d1e39a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "research-group-sharing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, " Sharing a tree with a group allows members of the group to explore the tree together. Sharing a tree does not allow anyone to edit it. ", -1))
const _hoisted_3 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_4 = { class: "list-unstyled related-list" }
const _hoisted_5 = { class: "item-actions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "actions" }

import { computed, ref } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useDataGroupInviteStore } from '@/gp/DataGroupInviteStore'
import { ItemPermissions, PrincipalType, InvitationResult, DataGroupMember, DataGroupInvite } from '@/gp/GroupAdminModel'
import { PlusIcon } from '@zhuowenli/vue-feather-icons'
import { LoadMode } from '@/util/AsyncData'
import { isDefined } from '@/util/TypeScriptUtil'
import FamilyGroupItem from '@/manage/familygroups/FamilyGroupItem.vue'
import DataGroupShareModal from '@/manage/datagroups/DataGroupShareModal.vue'
import DataGroupInviteModal from '@/manage/datagroups/DataGroupInviteModal.vue'
import DataGroupMemberRemoveModal from '@/manage/datagroups/DataGroupMemberRemoveModal.vue'
import { PendingStatus } from '@/util/AppUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchGroupSharing',
  props: {
  dataGroupId: String
},
  setup(__props) {

const props = __props;



const showClosedRequestsRef = ref(false)

const dataGroupShareModalRef = ref<InstanceType<typeof DataGroupShareModal>>()
const dataGroupInviteModalRef = ref<InstanceType<typeof DataGroupInviteModal>>()
const removeFamilyGroupModalRef = ref<InstanceType<typeof DataGroupMemberRemoveModal>>()

const dataGroupStore = useDataGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const dataGroupInviteStore = useDataGroupInviteStore()

const permissionsRef = computed(() => dataGroupStore.getAsyncPermissions(props.dataGroupId, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const canEditSharingRef = computed(() => (permissionsRef.value & ItemPermissions.ModifyPermissions) > 0)

const familyGroupMembersRef = computed(() => {
  return dataGroupMemberStore.getMembersForDataGroups([props.dataGroupId], LoadMode.EnsureLoaded)
    .filter(m => m.principalType == PrincipalType.FamilyGroup)
})
const dataGroupInvitesRef = computed(() => {
  const inviteIds = dataGroupInviteStore.getAsyncKeyListForDataGroup(props.dataGroupId, LoadMode.EnsureLoaded)?.data?.keys ?? []
  return dataGroupInviteStore.getAsyncInviteList(inviteIds) // loaded with key list
    .map(a => a.data).filter(isDefined)
    .filter(inv => showClosedRequestsRef.value || inv.result == InvitationResult.Pending)
})
const isSharedOrInvitedRef = computed(() => familyGroupMembersRef.value.length || dataGroupInvitesRef.value.length)

function onSelectDataGroupInvite(inv: DataGroupInvite) {
  dataGroupInviteModalRef.value?.openEdit(inv.id!)
}

function onShare() {
  const familyGroupIds = familyGroupMembersRef.value.map(m => m.principalId!)
  familyGroupIds.push(...dataGroupInvitesRef.value.map(inv => inv.principalId!))
  dataGroupShareModalRef.value?.open(props.dataGroupId!, familyGroupIds)
}

function onRequestShare(familyGroupId: string) {
  dataGroupInviteModalRef.value?.openNew(props.dataGroupId!, familyGroupId)
}

function onRemoveFamilyGroup(dm: DataGroupMember) {
  removeFamilyGroupModalRef.value?.open(dm)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!isSharedOrInvitedRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This tree is not shared with any groups. "))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataGroupInvitesRef.value, (inv) => {
        return (_openBlock(), _createElementBlock("li", {
          key: inv.id
        }, [
          _createVNode(FamilyGroupItem, {
            "family-group-id": inv.principalId,
            "select-mode": "",
            status: _unref(PendingStatus),
            onClick: ($event: any) => (onSelectDataGroupInvite(inv))
          }, null, 8, ["family-group-id", "status", "onClick"])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(familyGroupMembersRef.value, (dm) => {
        return (_openBlock(), _createElementBlock("li", {
          key: dm.id
        }, [
          _createVNode(FamilyGroupItem, {
            "family-group-id": dm.principalId
          }, null, 8, ["family-group-id"]),
          _createElementVNode("div", _hoisted_5, [
            (canEditSharingRef.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-inline btn-link",
                  onClick: ($event: any) => (onRemoveFamilyGroup(dm))
                }, " Remove ", 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (canEditSharingRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isSharedOrInvitedRef.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-inline btn-link",
                  onClick: onShare
                }, " Share with another group "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: onShare
                }, [
                  _createVNode(_unref(PlusIcon), {
                    size: "1.2x",
                    class: "mb-1"
                  }),
                  _createTextVNode(" Share this tree ")
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DataGroupShareModal, {
      ref_key: "dataGroupShareModalRef",
      ref: dataGroupShareModalRef,
      onRequestShare: onRequestShare
    }, null, 512),
    _createVNode(DataGroupInviteModal, {
      ref_key: "dataGroupInviteModalRef",
      ref: dataGroupInviteModalRef
    }, null, 512),
    _createVNode(DataGroupMemberRemoveModal, {
      ref_key: "removeFamilyGroupModalRef",
      ref: removeFamilyGroupModalRef
    }, null, 512)
  ]))
}
}

})